<template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Home</router-link> |      
      <router-link to="/decimal"> 小数展開 </router-link> | 
      <router-link to="/order"> 位数 </router-link> |
      <router-link to="/calc"> ガウス計算機 </router-link> |
      <router-link to="/div"> ガウス除法 </router-link> |
      <router-link to="/euclid"> 互除法 </router-link> |
      <router-link to="/mill"> ザギエの風車 </router-link>
    </div>
    <router-view />
    <footer>
      <div class="logo"><img src="@/assets/huemark.jpg" width="200" title="北教大ロゴ" /></div>
      <hr />
      <a href="http://aoki.hak.hokkyodai.ac.jp" target="_blank" rel="noopener noreferrer">青木 昌雄</a> (AOKI Masao)<br />
      北海道教育大学 函館校 国際地域学科 地域環境科学グループ<br />
      aoki.masao@h.hokkyodai.ac.jp
    </footer>
  </div>
</template>

<style>
#app {
    font-size: 16px;
}
div.title {
    margin-left: 0px;
    text-align: center;
    padding-top: 10px;
    font-size: 1.2rem;
    color: #0000ff;
}
h1 {
    font-family: sans-serif;
    font-size: 2rem;
    color:#000099;
}
h2 {
    color: #fff;
    font-size:1.6rem;
    background:linear-gradient(90deg,#8484ee,#eef);
    padding-top:20px;
    padding-bottom:3px;
    margin-top:0px;
    padding-left:3%;
    border-left:solid yellow 5px
}
h3 {
    font-size:1.4rem;
    padding-left:1%;
    margin-top:10px;
    margin-bottom:0px;
    padding-top: 10px;
    border-left:solid yellow 5px;
    }
section {
    margin-top:10px;
    padding-bottom:10px;
    background-color:#eef;
}
aside {
    margin-top:10px;
    background-color:#eeeeff;
    border:solid #8484ee 3px;
}
footer {
    position:relative;
    margin-top:10px;
    margin-bottom:10px;
    margin-left:10px;
    clear:both;
}
.logo {
    position:absolute;
    bottom:10px;
    right:10px;
}
p {
    padding-left:3%;
    padding-right:3%;
}
button {
    margin-left: 10px;
    margin-right:10px;
}
.error {
    color:red;
}
input[type="text"] {
    padding-left: 5px;
    padding-right:5px;
    width: 50px;
    height:25px;
    background-color:#fff;
}
input[type="text"].error {
    color:red;
    background-color:#fdd;
}
input[type="number"] {
    padding-left: 5px;
    padding-right:5px;
    width: 50px;
    height:20px;
    background-color:#fff;
}
input[type="number"]:invalid {
    color:red;
    background-color:#fdd;
}
table {
    margin-left:3%;
    border-collapse:collapse;
    text-align:center;
}
table.wide {
    width:94%;
    text-align:left;
}
table.time {
    width:94%;
}
th,td {
    padding:5px;
    border:solid 1px;
}
th {
    background-color:#ccccff
}
td {
    background-color:#f7f7ff
}
.warning {
    color: red;
}
[v-cloak] {
    display:none;
}
.contents {
    width: 94%;
    margin-left:3%;
}
#nav {
    text-align: center;
}

#nav a {
    font-weight: bold;
    font-size: 1.2rem;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color:#000099;
}
</style>
